import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Building2, Users } from 'lucide-react';

// 2-column promo grid displayed on the homepage below the 'What Drivers Say'
// reviews section. Two side-by-side cards (Corporate Events | Parties & Groups)
// mirror the split design of the main hero section. Stacks to 1-column on mobile.
export default function GroupBookingPromo() {
  const cards = [
    {
      to: '/corporate',
      eyebrow: 'B2B · CORPORATE',
      title: 'Corporate Events\n& Team Building',
      desc: 'Exclusive venue hire, mobile sim rigs, and brand activations for your next corporate event.',
      cta: 'EXPLORE CORPORATE',
      icon: Building2,
      image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&q=80&auto=format&fit=crop',
    },
    {
      to: '/parties',
      eyebrow: 'B2C · GROUPS',
      title: 'The Ultimate\nSim Racing Party',
      desc: 'Junior racers, adult birthdays, stag & hen dos, and custom group hire. Unforgettable racing experiences.',
      cta: 'EXPLORE PARTIES',
      icon: Users,
      image: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=1200&q=80&auto=format&fit=crop',
    },
  ];

  return (
    <section className="py-16 px-6 lg:px-10 border-t border-white/5 bg-[#0d0d0f]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 text-center">
          <p className="text-primary text-xs font-bold tracking-widest mb-2">GROUP BOOKINGS</p>
          <h2 className="text-white font-black text-2xl md:text-4xl uppercase leading-tight">BOOK FOR A GROUP</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {cards.map((card, i) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={card.to}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                <Link to={card.to} className="group block relative overflow-hidden bg-[#1a1a1f] aspect-[16/10] border border-white/5 hover:border-primary/30 transition-colors">
                  <img
                    src={card.image}
                    alt={card.title.replace('\n', ' ')}
                    width={1200}
                    height={750}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0f] via-[#0d0d0f]/60 to-[#0d0d0f]/20" />
                  <div className="relative z-10 h-full flex flex-col justify-end p-6 md:p-10">
                    <div className="flex items-center gap-2 mb-2">
                      <Icon className="w-4 h-4 text-primary" />
                      <p className="text-primary text-[11px] font-bold tracking-[0.3em]">{card.eyebrow}</p>
                    </div>
                    <h3 className="text-white font-black uppercase leading-[0.9] mb-3 whitespace-pre-line" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.25rem)' }}>
                      {card.title}
                    </h3>
                    <p className="text-white/60 text-xs max-w-xs mb-4 leading-relaxed">{card.desc}</p>
                    <span className="inline-flex items-center gap-2 bg-primary text-white font-bold text-xs tracking-widest px-5 py-2.5 w-fit group-hover:bg-primary/90 transition-colors">
                      {card.cta} <ArrowRight className="w-3.5 h-3.5" />
                    </span>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}